<template>
    <v-app>
        <v-main>
            <v-container fill-heigth>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="6">
                        <v-card class="elevation-12">
                            <v-toolbar color="primary" dark flat>
                                <v-toolbar-title>Inicio de sesión</v-toolbar-title>                                
                            </v-toolbar>
                            <v-card-text>
                                <v-form v-model="datosValidos" ref="form">                                    
                                    <v-text-field 
                                        id='Username'
                                        label="Nombre de usuario" 
                                        single-line
                                        color="primary"
                                        :rules="[rules.required, rules.min]"
                                        prepend-icon="mdi-account"
                                        v-model="username"
                                        @keyup.enter="iniciarSesion"
                                    ></v-text-field>
                                    <v-text-field
                                        id='Password'
                                        v-model="password"
                                        label="Contraseña"
                                        color="primary"
                                        prepend-icon="mdi-lock"
                                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[rules.required, rules.min]"
                                        :type="show1 ? 'text' : 'password'"
                                        @click:append="show1 = !show1"
                                        @keyup.enter="iniciarSesion"
                                    >
                                    </v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn id='botonIngresar' color="primary" dark @click="iniciarSesion">Ingresar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

import store from '../store'


export default {
    name: 'Login',
    methods: {
        iniciarSesion() {
            
            this.validar()
                if (this.datosValidos) {
                    store.dispatch('usuarios/intentarLoggearse', {Username: encodeURIComponent(this.username), Password: encodeURIComponent(this.password)})
                } else {
                    store.dispatch("snackbar/mostrar", "Datos incompletos")
                }
        },

        validar() {
            this.$refs.form.validate()
        }
    },
    data() {
        return {
            username: '',
            password: '',
            show1: false,
            rules: {
                required: value => !!value || 'Obligatorio',
                min: value => value.length>=3 || 'Mínimo 3 caracteres'
            },
            datosValidos: false
        }
    },
    created() {
        store.dispatch('actualizarTituloPrincipal', 'Inicio de sesión')
    }
}
</script>